<template>

    <div class="page-content">
        <div class="container-fluid">

            <Breadcrumb
                :pgTitle="$t('nav.settings')"
                :pgIcon="'bx bx-wrench'"
                :refs="refs"
                :addNew="addNew">
            </Breadcrumb>


            <DataTable
                :refs="refs"
                :colspan=5

                :hasHashId=true
                :hasMultiSelect=false
                :hasBulkAction=false
                :HasExport=true
                :hasShowEntries=true

                :hasTitle=true
                :title="$t('view.name')"
                
                :hasDate=true
                :hasStatus=true
                :hasActions=true

                :actionable=true
                :sorDataTable=true

                v-on:hasAddNewPermission="handlePermissoinChange">
            </DataTable>

        </div>
    </div>

</template>

<script>
export default {
    name: 'List',
    components: {
        Breadcrumb: () => import('@/components/Breadcrumb.vue'),
        DataTable: () => import('@/components/DataTable.vue')
    },
    data(){
        return {    
            //
            addNew: false,
            refs: 'settings',
        }
    },
    watch: {
        //
    },
    mounted() {},
    created() {
        //
    },
    methods: {
        handlePermissoinChange(event) {
            this.addNew = event;
        },
    },
}
</script>
